export const VALIDATE_MODEL_PRICING = `
  mutation ValidateModelPricing($modelId: ID!) {
    validateModelPricing(modelId: $modelId) {
      modelId
      region
      inputPricePerMillion
      outputPricePerMillion
      refreshedAt
    }
  }
`
